import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { NavigationMenuListProps } from "../types";

function NavigationMenuList({ className, ...props }: NavigationMenuListProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <NavigationMenuPrimitive.List
      data-slot="navigation-menu-list"
      className={cn(
        "group flex flex-1 list-none items-center justify-center gap-1",
        className,
        classes,
      )}
      {...native}
    />
  );
}

NavigationMenuList.displayName = "NavigationMenu.List";

export default NavigationMenuList;
